<div class="portdescription">
    <p>{{PortInfo?.gpiDescription}}
    </p>
</div>